import Modifier from 'ember-modifier';
import { registerDestructor } from '@ember/destroyable';

interface OnIntersectModifierSignature {
  Args: {
    Positional: [callback: () => void];
    Named: {
      rootMargin?: string;
      threshold?: number | number[];
      disabled?: boolean;
    };
  };
}

export default class OnIntersectModifier extends Modifier<OnIntersectModifierSignature> {
  private observer?: IntersectionObserver;

  modify(
    element: Element,
    [callback]: [() => void],
    {
      rootMargin = '0px 0px 400px 0px',
      threshold = 0,
      disabled = false,
    }: OnIntersectModifierSignature['Args']['Named']
  ) {
    if (this.observer) {
      this.observer.disconnect();
    }

    if (disabled) {
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            callback();
          }
        }
      },
      { rootMargin, threshold }
    );

    this.observer.observe(element);

    registerDestructor(this, () => {
      this.observer?.disconnect();
    });
  }
}
